import { render, staticRenderFns } from "./Corrected.vue?vue&type=template&id=759c90d3&scoped=true&"
import script from "./Corrected.vue?vue&type=script&lang=js&"
export * from "./Corrected.vue?vue&type=script&lang=js&"
import style0 from "./Corrected.vue?vue&type=style&index=0&id=759c90d3&prod&lang=scss&"
import style1 from "./Corrected.vue?vue&type=style&index=1&id=759c90d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759c90d3",
  null
  
)

export default component.exports